import { Colors } from './../../types/theme';

export const colors: Colors = {
	ui: {
		limeGreen: '#c3dc87',
		paleGreen: '#f5faf0',
		lightBlue: '#78cde6',
		barIlanGreen: '#004128',
		jungleGreen: '#006937',
		barIlanTextGreen: '#003535',
		barIlanTextLightGreen: '#0b6938',
		lightGray: '#f3f4f8',
		catalogLightGreen: '#f6f9f1',
		catalogLightGray: '#f9f9fb',
		darkForestGreen: '#01280f',
		white: '#ffffff'
	},
};
